/* eslint-disable */
import bi1_data_validation from '../../base_i1_datavalidation'
import { RC, CR, AJRS } from '../../base_i2_success_codes'
import base_i3_log from '../../base_i3_logging'
import { ajax } from 'noquery-ajax'

function getNGPRulesInformation(firebase_email, firebase_token, ngp_uid, key_list) {
  return new Promise(function (resolve, reject) {
    var return_msg = "";
    var debug_data = [];
    var call_result = {};
    var task_id = "p2s7t12getNGPRulesInformation";
    var rules_information = {};

    ///// input validation
    call_result = bi1_data_validation.is_email_address(firebase_email);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(firebase_token);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_array(key_list);
    debug_data.push(call_result);

    var validation_failed_flag = false;
    for (var index in debug_data) {
      if (debug_data[index][CR.success] != RC.success) {
        validation_failed_flag = true;
        break;
      }
    }

    if (validation_failed_flag == true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      reject({ success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data, group_history: group_history });
    }
    /////</end> input validation

    var params = {
      'p2s7_firebase_email': firebase_email,
      'p2s7_token': firebase_token,
      'p2s7t12_ngp_uid': ngp_uid.replace("ngp_", ""),
      'p2s7t12_key_list': JSON.stringify(key_list)
    }

    ajax({
      url: window.G_ajax_test_domain + '/json-requests/p2s7t12-get-notification-group-rule-information',
      method: 'POST',
      data: params,
      success: function (result) {
        rules_information = result;
        resolve({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data, rules_information: rules_information});
      },
      error: function (err) {
        if (err.status == 401) {
          window.G_firebase_auth.bi5forceTokenRefresh();
        }
        return_msg += "Failed to get notification group rules information data, error data:" + JSON.stringify(err);
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
        reject({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data, rules_information: rules_information});
      }
    })

  });
};

export default getNGPRulesInformation 



// WEBPACK FOOTER //
// ./src/watchdog_includes/json_tasks/p2s7/p2s7t12.js